import { useEffect, useMemo, useState} from "react";
import { Button } from "reactstrap";
import { ContractStates } from "../utils/constants/common";
import { useDispatch, useSelector } from "react-redux";
import { addCommercialContract, buyerConfirm, sellerConfirm, updateCommercialDB, updateCommercialDB2,  updateBuyerConfirmation, updateSellerConfirmation, updateAllSubjectsLift, updateAddCommercialContract  } from "../Redux/products/slice";
import { toast } from "react-toastify";
import { ToastProperties } from '../utils/constants/toastProperties';
import { 
  MantineProvider, 
  Modal,
  ScrollArea,
  Stepper, 
  Grid, 
  TextInput, 
  Card, 
  Badge, 
  Text, 
  Group, 
  Divider, 
  Box, 
  Select, Center
} from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { FormattedMessage, useIntl } from 'react-intl';
import { transfer } from "../Redux/transfer/slice";
import { BASE_URL } from '../Redux/apiConfig';
import { all } from "axios";
// TransferModal import removed

const ImprovedContractLayout = ({ selected, getStatusColor, intl }) => {
  return (
    <div>
      {/* Status */}
      <div style={{ marginBottom: '20px' }}>
        <Group position="apart" style={{ marginBottom: '10px' }}>
          <Text weight={600}>
            <FormattedMessage id="modal.contract.status" />:
          </Text>
          <Badge color={getStatusColor(selected.contractState)}>
            {selected.contractState === 'Completed' ? 
              <FormattedMessage id="status.archived" /> : 
              selected.contractState}
          </Badge>
        </Group>
        <Divider />
      </div>

      {/* Contract Details */}
      <div style={{ marginBottom: '15px' }}>
        <Text weight={600} style={{ marginBottom: '10px' }}>
          <FormattedMessage id="modal.contract.details.header" />
        </Text>
        <div style={{ paddingLeft: '10px' }}>
          <Text size="sm"><strong><FormattedMessage id="product.id" />:</strong> {selected.productSKU || '-'}</Text>
          <Text size="sm"><strong><FormattedMessage id="modal.contract.id" />:</strong> {selected.contractId || '-'}</Text>
          <Text size="sm"><strong><FormattedMessage id="contract.details" />:</strong> {selected.contractDetails || '-'}</Text>
        </div>
      </div>

      {/* Product Details */}
      <div style={{ marginBottom: '15px' }}>
        <Text weight={600} style={{ marginBottom: '10px' }}>
          <FormattedMessage id="modal.contract.product.header" />
        </Text>
        <div style={{ paddingLeft: '10px' }}>
          <Text size="sm"><strong><FormattedMessage id="product.period" />:</strong> {selected.period || '-'}</Text>
          <Text size="sm"><strong><FormattedMessage id="product.quantity" />:</strong> {selected.quantity || '-'}</Text>
          <Text size="sm"><strong><FormattedMessage id="product.price" />:</strong> {selected.price || '-'}</Text>
          <Text size="sm"><strong><FormattedMessage id="card.location" />:</strong> {selected.location || '-'}</Text>
          <Text size="sm"><strong><FormattedMessage id="product.notes" />:</strong> {selected.productNotes || '-'}</Text>
        </div>
      </div>

      {/* Parties */}
      <div style={{ marginBottom: '15px' }}>
        <Text weight={600} style={{ marginBottom: '10px' }}>
          <FormattedMessage id="modal.contract.parties.header" />
        </Text>
        <div style={{ paddingLeft: '10px' }}>
          <Text size="sm"><strong><FormattedMessage id="contract.seller1" /></strong> {selected.SellerID || '-'}</Text>
          <Text size="sm"><strong><FormattedMessage id="contract.buyer1" /></strong> {selected.BuyerID || '-'}</Text>
        </div>
      </div>
    </div>
  );
};

export default function UpdateContractModal({ open = false, toggle, refresh, isUpdate, selected }) {
  const dispatch = useDispatch();
  const { updateCommercialMessage, buyerConfirmationD, sellerConfirmationD, allSubjectsLiftedD, addCommercialContractD } = useSelector(state => state.products);
  const filtedState = (s) => ContractStates.find(ec => ec.id === s);

  const [selectedState, setSelectedState] = useState(filtedState(selected.contractState));
  const isSmallScreen = useMediaQuery('(max-width: 768px)'); 
  const intl = useIntl();
  const [updateSuccessful, setUpdateSuccessful] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState('Other');
  const [priceError, setPriceError] = useState('');
  const [validationErrors, setValidationErrors] = useState({});
  const [isTransferring, setIsTransferring] = useState(false);
  const [hasHandledUpdate, setHasHandledUpdate] = useState(false);
  const [userinfo, setUserinfo] = useState(null);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  // Removed showTransferModal state

  const [usdcBalance, setUsdcBalance] = useState(null); // ✅ ADD THIS
  const [loadingBalance, setLoadingBalance] = useState(false); // ✅ ADD THIS
  const [pendingBuyerConfirm, setPendingBuyerConfirm] = useState(false);
  
  const { message: transferMessage, error: transferErr, isTransferring: transferLoading, success: transferSuccess } = useSelector((state) => state.transfer);
  const [transferToastId, setTransferToastId] = useState(null);

  const [formValues, setFormValues] = useState({
    productSKU: selected.productSKU || '',
    period: selected.period || '',
    quantity: selected.quantity || '',
    price: selected.price || '',
    location: selected.location || '',
    productNotes: selected.productNotes || '',
    contractDetails: selected.contractDetails || ''
  });

  // Auto-refresh on success, then reset status to prevent infinite loop
  useEffect(() => {
    const isSuccess =
      (allSubjectsLiftedD.status === "Success") ||
      (buyerConfirmationD.status === "Success") ||
      (sellerConfirmationD.status === "Success") ||
      (addCommercialContractD.status === "Success");

    if (isSuccess && typeof refresh === "function") {
      refresh();
      // Reset confirmation statuses to prevent infinite loop
      if (buyerConfirmationD.status === "Success") {
        dispatch(updateBuyerConfirmation({ status: null }));
      }
      if (sellerConfirmationD.status === "Success") {
        dispatch(updateSellerConfirmation({ status: null }));
      }
      if (allSubjectsLiftedD.status === "Success") {
        dispatch(updateAllSubjectsLift({ status: null }));
      }
      if (addCommercialContractD.status === "Success") {
        dispatch(updateAddCommercialContract({ status: null }));
      }
    }
  }, [buyerConfirmationD, allSubjectsLiftedD, sellerConfirmationD, addCommercialContractD, refresh, dispatch]);

  // Auto-refresh 
  useEffect(() => {
    if (typeof refresh === "function") {
      const interval = setInterval(() => {
        refresh();
      }, 180000); // Refresh every 3 minutes

      return () => clearInterval(interval);
    }
  }, [refresh]);
  

  useEffect(() => {
    try {
      const storedUserinfo = JSON.parse(localStorage.getItem("userinfo"));
      setUserinfo(storedUserinfo);
      if (storedUserinfo?.accountId) {
        fetchUSDCBalance(storedUserinfo.accountId);
      }
    } catch (error) {
      console.error('Failed to parse user info from localStorage:', error);
      setUserinfo(null);
    }
  }, []);

  const fetchUSDCBalance = async (accountId) => {
    setLoadingBalance(true);
    try {
      const response = await fetch(`${BASE_URL}/api/getUSDCBalance/${accountId}`);
      if (!response.ok) {
        throw new Error('Failed to fetch balance');
      }
      const data = await response.json();
      setUsdcBalance(data.balance || 0);
    } catch (error) {
      console.error('Error fetching USDC balance:', error);
      setUsdcBalance(0);
    } finally {
      setLoadingBalance(false);
    }
  };

  useEffect(() => {
    setFormValues({
      productSKU: selected.productSKU || '',
      period: selected.period || '',
      quantity: selected.quantity || '',
      price: selected.price || '',
      location: selected.location || '',
      productNotes: selected.productNotes || '',
      contractDetails: selected.contractDetails || ''
    });
  }, [selected]);

  useEffect(() => {
    if (!open) {
      setIsTransferring(false);
      setUpdateSuccessful(false);
      setPriceError('');
      setValidationErrors({});
      setHasHandledUpdate(false);
    }
  }, [open]);


  useEffect(() => {
    if (formValues.price.trim()) {
      if (paymentMethod === 'Wallet') {
        if (!formValues.price.trim().toUpperCase().endsWith('USDC')) {
          setPriceError('For Wallet payment, price must end with USDC');
        } else {
          setPriceError('');
        }
      } else {
        setPriceError('');
      }
    }
  }, [paymentMethod, formValues.price]);

  useEffect(() => {
    if (updateCommercialMessage && !hasHandledUpdate) {
      setUpdateSuccessful(true);
      setHasHandledUpdate(true);
      toggle(true);
    }
  }, [updateCommercialMessage, hasHandledUpdate, toggle]);

  useEffect(() => {
    if (transferSuccess && pendingBuyerConfirm) {
      (async () => {
        try {
          await dispatch(buyerConfirm({
            ...selected,
            contractId: selected.contractId,
            sku: selected.sku,
            requestUserId: userinfo.userId,
            ownerAccountID: userinfo.accountId,
            state: selected.contractState,
            productRefId: selected.productRefID,
            BuyerID: selected.BuyerID,
            contractRefId: selected.contractRefID,
          }));
        } catch (error) {
          toast.error(intl.formatMessage({ id: 'toast.contract.buyersigned.error' }), {
            ...ToastProperties
          });
        } finally {
          setIsTransferring(false);
          setPendingBuyerConfirm(false);
        }
      })();
    } else if (transferMessage && !pendingBuyerConfirm) {
      toast.success(transferMessage, {
        ...ToastProperties
      });
      setIsTransferring(false);
    }
    if (transferErr) {
      toast.error(transferErr, {
        ...ToastProperties
      });
      setIsTransferring(false);
      setPendingBuyerConfirm(false);
    }
  }, [transferSuccess, pendingBuyerConfirm]);

  // Show transfer toast when transfer starts
  useEffect(() => {
    if (isTransferring && !transferToastId) {
      const id = toast.info('Transferring, please wait...', {
        ...ToastProperties,
        autoClose: false,
      });
      setTransferToastId(id);
    }
  }, [isTransferring, transferToastId]);

  // Dismiss transfer toast after transferMessage
  useEffect(() => {
    if (transferMessage && transferToastId) {
      toast.dismiss(transferToastId);
      setTransferToastId(null);
    }
  }, [transferMessage, transferToastId]);

  const handleBuyerSign = async () => {
    if (!userinfo) {
      toast.error('User not authenticated. Please log in.');
      return;
    }
    
    if (selected.paymentMethod === 'Wallet' && userinfo?.userId === selected.BuyerID && selected.contractState === 'AllSubjectsLifted') {
      // ✅ Fetch balance before showing modal
      await fetchUSDCBalance(userinfo.accountId);
      setShowPaymentModal(true);
      return;
    }
    
    try {
      await dispatch(buyerConfirm({
        ...selected,
        contractId: selected.contractId,
        sku: selected.sku,
        requestUserId: userinfo.userId,
        ownerAccountID: userinfo.accountId,
        state: selected.contractState,
        productRefId: selected.productRefID,
        BuyerID: selected.BuyerID,
        contractRefId: selected.contractRefID,
      }));
       
    setTimeout(() => {toggle(true); }, 2000);

    } catch (error) {
      console.error("Error checking payment status:", error);
      toast.error("Error checking payment status");
    }
  };
  
  const handleConfirmPayment = async () => {
    setShowPaymentModal(false);
    setIsTransferring(true);

    const payload = {
      sender: userinfo.accountId,
      recipient: selected.SellerID,
      amount: parseFloat(selected.price.replace(/[^\d.-]/g, "")),
      contractRefId: selected.contractRefID,
    };

    try {
      await dispatch(transfer(payload));
      setPendingBuyerConfirm(true);
    } catch (error) {
      console.error("Error confirming buyer sign:", error);
      toast.error(intl.formatMessage({ id: 'toast.contract.buyersigned.error' }), {
        ...ToastProperties
      });
      setIsTransferring(false);
    }
    toggle(true);
  };

  const validateInput = (field, value) => {
    const trimmedValue = value.trim();
    
    switch (field) {
      case 'period':
        if (trimmedValue.length > 100) return 'Period must be less than 100 characters';
        if (trimmedValue && !/^[a-zA-Z0-9\s\-.,]+$/.test(trimmedValue)) return 'Period contains invalid characters';
        break;
      case 'quantity':
        if (trimmedValue.length > 50) return 'Quantity must be less than 50 characters';
        break;
      case 'price':
        if (trimmedValue.length > 50) return 'Price must be less than 50 characters';
        break;
      case 'location':
        if (trimmedValue.length > 200) return 'Location must be less than 200 characters';
        if (trimmedValue && !/^[a-zA-Z0-9\s\-.,#]+$/.test(trimmedValue)) return 'Location contains invalid characters';
        break;
      case 'productNotes':
        if (trimmedValue.length > 500) return 'Product notes must be less than 500 characters';
        break;
      case 'contractDetails':
        if (trimmedValue.length > 1000) return 'Contract details must be less than 1000 characters';
        break;
      default:
        break;
    }
    return null;
  };

  const handleInputChange = (field, value) => {
    const sanitizedValue = value.replace(/^\s+/, '');
    const error = validateInput(field, sanitizedValue);
    
    setFormValues(prev => ({
      ...prev,
      [field]: sanitizedValue
    }));
    
    if (field === 'price') {
      if (error) {
        setPriceError(error);
      } else if (paymentMethod === 'Wallet' && sanitizedValue.trim()) {
        if (!sanitizedValue.trim().toUpperCase().endsWith('USDC')) {
          setPriceError('For Wallet payment, price must end with USDC');
        } else {
          setPriceError('');
        }
      } else {
        setPriceError('');
      }
    }
    
    if (error && field !== 'price') {
      toast.error(error);
    }
  };

  const handleSave = () => {
    const errors = {};
    Object.keys(formValues).forEach(field => {
      if (field !== 'productSKU') {
        const error = validateInput(field, formValues[field]);
        if (error) {
          errors[field] = error;
        }
      }
    });
    
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      toast.error('Please fix validation errors before saving');
      return;
    }
    
    if (paymentMethod === 'Wallet' && formValues.price.trim()) {
      if (!formValues.price.trim().toUpperCase().endsWith('USDC')) {
        toast.error('For Wallet payment, price must end with USDC');
        return;
      }
    }
    
    setValidationErrors({});
    
    const payload = {
      ...selected,
      "CONTRACTID": selected.contractId,
      BUYERID: selected.BuyerID,
      SELLERID: selected.SellerID,
      period: formValues.period.trim(),
      quantity: formValues.quantity.trim(),
      price: formValues.price.trim(),
      location: formValues.location.trim(),
      productNotes: formValues.productNotes.trim(),
      contractDetails: formValues.contractDetails.trim(),
      paymentMethod: paymentMethod,
      event: 'contractUpdate',
    };
    dispatch(updateCommercialDB(payload));
    setHasHandledUpdate(false);
    
    setTimeout(() => {
      if (!hasHandledUpdate) {
        toggle(true);
      }
    }, 3000);
  };

  const handleAllSubjects = () => {
    if (!userinfo) {
      toast.error('User not authenticated. Please log in.');
      return;
    }
    
    const payload = {
      ...selected,
      "CONTRACTID": selected.contractId,
      BUYERID: selected.BuyerID,
      SELLERID: selected.SellerID,
      "state": "AllSubjectsLifted",
      requestUserId: userinfo.userId,
      ownerAccountID: userinfo.accountId,
      productRefId: selected.productRefID,
      price: selected.price,
    };
    dispatch(updateCommercialDB2(payload));
    toggle(true);
  };

  const handleSellerSign = () => {
    if (!userinfo) {
      toast.error('User not authenticated. Please log in.');
      return;
    }
    
    dispatch(sellerConfirm({
      ...selected,
      contractId: selected.contractId,
      sku: selected.sku,
      requestUserId: userinfo.userId,
      ownerAccountID: userinfo.accountId,
      state: selected.contractState,
      productRefId: selected.productRefID,
      BuyerID: selected.BuyerID,
      contractRefId: selected.contractRefID,
    }));

    setTimeout(() => {
      toggle(true);
    }, 3000);
  };

  const updatePayload = () => {
    if (!userinfo) {
      toast.error('User not authenticated. Please log in.');
      return null;
    }
    
    return {
      ...selected,
      productRefId: selected.productRefID,
      contractId: selected.contractId,
      sellerId: selected.SellerID,
      buyerId: selected.BuyerID,
      contractDetails: formValues.contractDetails,
      price: formValues.price,
      location: formValues.location,
      period: formValues.period,
      quantity: formValues.quantity,
      productNotes: formValues.productNotes,
      requestUserId: userinfo.userId,
      ownerAccountID: userinfo.accountId,
      contractRefId: selected.contractRefID,
    };
  };

  const handleConfirmOrder = () => {
    if (selected.contractState === "Completed") {
      toast.info("You cannot confirm order as this contract is already completed", {
        ...ToastProperties
      });
    } else if (selected.contractState === "Draft") {
      toast.info("You cannot confirm as there is no Buyer, this is a draft contract", {
        ...ToastProperties
      });
    } else {
      const payload = updatePayload();
      if (payload) {
      dispatch(addCommercialContract(payload));
      } else {
        return;
      }
    }

    setTimeout(() => {
      toggle(true);
    }, 3000);
  };

  const isUpdateDisabled = useMemo(() => {
    return selected.contractState === 'Completed' || selected.contractState === 'AllSubjectsLifted';
  }, [selected.contractState]);

  const isDisabled = useMemo(() => {
    return selected.contractState === 'Completed' || selected.contractState === 'Draft';
  }, [selected.contractState]);

  const canUserEdit = useMemo(() => {
    const isBuyer = userinfo?.userId === selected.BuyerID;
    return !isBuyer;
  }, [userinfo, selected.BuyerID]);

  const showEditForm = isUpdate && canUserEdit;

  const getStepperStep = () => {
    if (!userinfo) return 0;
    
    switch (selected.contractState) {
      case 'Draft':
        return 0;
      case 'InNegotiation':
        return 0;
      case 'OnSubjects':
        return 1;
      case 'AllSubjectsLifted':
        return 2;
      case 'ConfirmedByBuyer':
        return 3;
      case 'ConfirmedBySeller':
        return 3;
      case 'Completed':
        return 3;
      default:
        return 0;
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'Draft':
        return 'gray';
      case 'InNegotiation':
        return 'blue';
      case 'OnSubjects':
        return 'cyan';
      case 'AllSubjectsLifted':
        return 'teal';
      case 'ConfirmedByBuyer':
        return 'indigo';
      case 'ConfirmedBySeller':
        return 'violet';
      case 'Completed':
        return 'green';
      default:
        return 'gray';
    }
  };


  return (
    <MantineProvider 
      withGlobalStyles
      withNormalizeCSS
      theme={{
        primaryColor: 'blue',
        defaultRadius: 'md',
      }}
    >
      {/* Main Contract Modal */}
      <Modal
        opened={open}
        onClose={toggle}
        title={
          showEditForm ? (
            <FormattedMessage id="modal.updateContract.title" />
          ) : (
            <FormattedMessage id="modal.contract.view.title" />
          )
        }
        size="lg"
        styles={{
          modal: {
            maxHeight: '85vh',
          },
        }}
      >
        <ScrollArea style={{ maxHeight: '60vh'  }} p="md">
          {showEditForm ? (
            <Grid>
              <Grid.Col>
                <TextInput
                  label={intl.formatMessage({ id: "product.id" })}
                  readOnly
                  value={formValues.productSKU}
                  mb="md"
                />
              </Grid.Col>
              <Grid.Col>
                <TextInput
                  label={intl.formatMessage({ id: "product.period" })}
                  value={formValues.period}
                  onChange={(e) => handleInputChange('period', e.target.value)}
                  error={validationErrors.period}
                  maxLength={100}
                  mb="md"
                />
              </Grid.Col>
              <Grid.Col>
                <TextInput
                  label={intl.formatMessage({ id: "product.quantity" })}
                  value={formValues.quantity}
                  onChange={(e) => handleInputChange('quantity', e.target.value)}
                  error={validationErrors.quantity}
                  maxLength={50}
                  mb="md"
                />
              </Grid.Col>
              <Grid.Col>
               <Select
                label={intl.formatMessage({ id: "contract.payment" })}
                data={['Other', 'Wallet']}
                value={paymentMethod}
                onChange={(value) => setPaymentMethod(value)}
                placeholder="Select payment method"
                nothingFound="No options"
                withinPortal={false}
                maxDropdownHeight={100}
                styles={{
                  dropdown: {
                    maxHeight: '100px',
                    overflow: 'auto'
                  }
                }}
              />
              </Grid.Col>
              <Grid.Col>
                <TextInput
                  label={intl.formatMessage({ id: "marketplace.product.price" })}
                  value={formValues.price}
                  onChange={(e) => handleInputChange('price', e.target.value)}
                  error={priceError || validationErrors.price}
                  maxLength={50}
                  mb="md"
                />
              </Grid.Col>
              <Grid.Col>
                <TextInput
                  label={intl.formatMessage({ id: "card.location" })}
                  value={formValues.location}
                  onChange={(e) => handleInputChange('location', e.target.value)}
                  error={validationErrors.location}
                  maxLength={200}
                  mb="md"
                />
              </Grid.Col>
              <Grid.Col>
                <TextInput
                  label={intl.formatMessage({ id: "product.notes" })}
                  value={formValues.productNotes}
                  onChange={(e) => handleInputChange('productNotes', e.target.value)}
                  error={validationErrors.productNotes}
                  maxLength={500}
                  mb="md"
                />
              </Grid.Col>
              <Grid.Col>
                <TextInput
                  label={intl.formatMessage({ id: "contract.details" })}
                  value={formValues.contractDetails}
                  onChange={(e) => handleInputChange('contractDetails', e.target.value)}
                  error={validationErrors.contractDetails}
                  maxLength={1000}
                  mb="md"
                />
              </Grid.Col>
            </Grid>
          ) : (
            <ImprovedContractLayout 
              selected={selected} 
              getStatusColor={getStatusColor} 
              intl={intl} 
            />
          )}
          
          {!showEditForm && selected.contractState === 'Completed' && (
            <Box mt="md">
              <Text weight={600} size="md">
                <FormattedMessage id="table.product" />:
              </Text>
            </Box>
          )}
        </ScrollArea>
        
        <Box p="md" style={{ borderTop: '1px solid #dee2e6' }}>
          <Group position="center" mb="md">
            {showEditForm ? (
              <>
                <Button color="primary" disabled={isUpdateDisabled} onClick={handleSave}>
                  <FormattedMessage id="button.save" />
                </Button>
                <Button color="danger" disabled={isUpdateDisabled} onClick={toggle}>
                  <FormattedMessage id="button.cancel" />
                </Button>
              </>
            ) : (
              <>
                <Button 
                  disabled={isDisabled || userinfo?.userId === selected.SellerID || selected.contractState !== 'InNegotiation'} 
                  color="success" onClick={handleConfirmOrder}>
                  <FormattedMessage id="button.buy" />
                </Button>
                <Button 
                  disabled={isDisabled || selected.contractState !== 'OnSubjects'}
                  color="info" onClick={handleAllSubjects}>
                  <FormattedMessage id="button.liftallsubjects"/>
                </Button>
                <Button 
                  disabled={isDisabled || userinfo?.userId === selected.SellerID || !(selected.contractState === 'ConfirmedBySeller' || selected.contractState === 'AllSubjectsLifted')}
                  color="warning" onClick={handleBuyerSign}>
                  <FormattedMessage id="button.buyersign" />
                </Button>
                <Button 
                  disabled={isDisabled || userinfo?.userId === selected.BuyerID || !(selected.contractState === 'ConfirmedByBuyer' || selected.contractState === 'AllSubjectsLifted')}
                  color="primary" onClick={handleSellerSign}>
                  <FormattedMessage id="button.sellersign" />
                </Button>
                <Button color="secondary" onClick={toggle}>
                  <FormattedMessage id="modal.contract.button.close" />
                </Button>
              </>
            )}
          </Group>
          
          <Stepper 
            active={getStepperStep()} 
            size="xs"
            orientation={isSmallScreen ? 'vertical' : 'horizontal'}
            color="blue"
            styles={{
              root: {
                margin: 'auto',
                width: '100%',
                maxWidth: '1200px',
              }
            }}
          >
            <Stepper.Step label={<FormattedMessage id="button.buy" />} />
            <Stepper.Step label={<FormattedMessage id="button.liftallsubjects" />} />
            <Stepper.Step 
              label={userinfo?.userId === selected.BuyerID ? 
                <FormattedMessage id="button.buyersign" /> : 
                <FormattedMessage id="button.sellersign" />}
            />
            <Stepper.Step 
              label={userinfo?.userId === selected.BuyerID ? 
                <FormattedMessage id="button.sellersign" /> : 
                <FormattedMessage id="button.buyersign" />}
            />
          </Stepper>
        </Box>
      </Modal>

      {/* Payment Confirmation Modal */}
      <Modal
        opened={showPaymentModal}
        onClose={() => setShowPaymentModal(false)}
        title={<FormattedMessage id="modal.payment.confirmation.title" />}
        size="md"
      >
        <Box p="md">
          <Text mb="md" size="sm" color="dimmed">
            <FormattedMessage id="modal.payment.confirmation.message" />
          </Text>
          
          <Divider my="sm" />
          
          {/* Current USDC Balance */}
          {loadingBalance ? (
            <Center p="md">
              <Text size="sm"><FormattedMessage id="loading.balance" /></Text>
            </Center>
          ) : (
            <>
              <Box 
                p="md" 
                mb="md"
                style={{ 
                  backgroundColor: '#f8f9fa',
                  borderRadius: '8px',
                  border: '1px solid #dee2e6'
                }}
              >
                <Group position="apart" mb="xs">
                  <Text weight={500} size="sm">
                    <FormattedMessage id="modal.payment.current.balance" />
                  </Text>
                  <Group spacing="xs">
                    <img
                      src="https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48/logo.png"
                      alt="USDC"
                      style={{ width: '20px', height: '20px' }}
                    />
                    <Text weight={600}>
                      {usdcBalance !== null ? usdcBalance.toFixed(2) : '0.00'}
                    </Text>
                    <Badge color="blue" size="sm">USDC</Badge>
                  </Group>
                </Group>
              </Box>

              {/* Payment Amount */}
              <Group position="apart" mb="xs" p="xs">
                <Text weight={500} size="sm">
                  <FormattedMessage id="modal.payment.confirmation.amount" />
                </Text>
                <Group spacing="xs">
                  <img
                    src="https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48/logo.png"
                    alt="USDC"
                    style={{ width: '18px', height: '18px' }}
                  />
                  <Text weight={600} color="red">
                    {selected?.price ? parseFloat(selected.price.replace(/[^\d.-]/g, "")).toFixed(2) : '0.00'}
                  </Text>
                </Group>
              </Group>
              
              <Divider my="sm" />
              
              {/* Remaining Balance */}
              <Group position="apart" mb="md" p="xs">
                <Text weight={600} size="sm">
                  <FormattedMessage id="modal.payment.remaining.balance" />
                </Text>
                <Group spacing="xs">
                  <img
                    src="https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48/logo.png"
                    alt="USDC"
                    style={{ width: '20px', height: '20px' }}
                  />
                  <Text weight={700} size="lg" color={
                    (usdcBalance - selected?.price ? parseFloat(selected.price.replace(/[^\d.-]/g, "")) : 0) >= 0 
                      ? 'green' 
                      : 'red'
                  }>
                    {(usdcBalance - (selected?.price ? parseFloat(selected.price.replace(/[^\d.-]/g, "")) : 0)).toFixed(2)}
                  </Text>
                  <Badge color="blue" size="sm">USDC</Badge>
                </Group>
              </Group>

              {/* Insufficient balance warning */}
              {(usdcBalance < (selected?.price ? parseFloat(selected.price.replace(/[^\d.-]/g, "")) : 0)) && (
                <Box 
                  p="sm" 
                  mb="md"
                  style={{ 
                    backgroundColor: '#fff3cd',
                    borderRadius: '6px',
                    border: '1px solid #ffc107'
                  }}
                >
                  <Text size="sm" color="orange" weight={500}>
                    <FormattedMessage id="modal.payment.insufficient.balance" />
                  </Text>
                </Box>
              )}
            </>
          )}
          
          {/* Recipient */}
          <Group position="apart" mb="md" p="xs">
            <Text weight={500} size="sm">
              <FormattedMessage id="modal.payment.confirmation.recipient" />
            </Text>
            <Text size="sm">{selected.SellerID}</Text>
          </Group>
          
          <Group position="right" mt="xl">
            <Button 
              color="secondary" 
              onClick={() => setShowPaymentModal(false)}
            >
              <FormattedMessage id="button.cancel.payment" />
            </Button>
            <Button 
              color="primary" 
              onClick={handleConfirmPayment}
              disabled={
                isTransferring || 
                transferLoading || 
                loadingBalance ||
                usdcBalance < (selected?.price ? parseFloat(selected.price.replace(/[^\d.-]/g, "")) : 0)
              }
            >
              {isTransferring || transferLoading ? 
                'Processing...' : 
                <FormattedMessage id="button.confirm.payment" />}
            </Button>
          </Group>
        </Box>
      </Modal>
    </MantineProvider>
  );
}